export default "__VITE_ASSET__B23M4tQp__"